<template>
	<div>
		<div class="modal" :class="{ hide: !loading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div>
		<template v-if="!loading">
			<checkoutCompleted v-if="resultType === 'complete'" v-bind="resultData"></checkoutCompleted>
			<checkoutPending v-else-if="resultType === 'pending'" v-bind="resultData"></checkoutPending>
			<checkoutFail v-else-if="resultType === 'failed'" v-bind="resultData"></checkoutFail>
		</template>
	</div>
</template>

<script>
import checkoutCompleted from './completed';
import checkoutPending from './pending';
import checkoutFail from './failed';
import config from '@/config/environment-config';

export default {
	name: 'PurchaseResult',
	components: {
		checkoutCompleted,
		checkoutFail,
		checkoutPending,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('checkout.title')}`,
		};
	},
	data() {
		return {
			resultType: null,
			resultData: {},
			loading: false,
		};
	},
	computed: {
		checkoutId() {
			return this.$route.query.checkoutId ? this.$route.query.checkoutId : '';
		},
		paymentResult() {
			return this.$route.query.result ? this.$route.query.result : '';
		},
		transactionId() {
			return this.$route.query.transaction_id ? this.$route.query.transaction_id : '';
		},
	},
	async mounted() {
		try {
			this.$a2s.view('purchase_completed_imp');
			this.loading = true;

			if (this.paymentResult === 'success') {
				const response = await this.$checkoutAPI.getTransactionSuccessResult(this.checkoutId);
				const data = response.data;
				const status = data.status;

				if (status === 'complete') {
					this.resultData = {
						orderNumber: data.orderNumber,
						orderDate: data.date,
						paymentInfo: data.paymentInfo,
						productPurchaseInfo: data.productPurchaseInfo,
					};

					this.dataLayerCompletedPending(data);
				}
				if (status === 'pending') {
					this.resultData = {
						orderNumber: data.orderNumber,
						orderDate: data.date,
					};

					this.dataLayerCompletedPending(data);
				}
				if (status === 'failed') {
					this.resultData = {
						orderNumber: data.orderNumber,
					};

					dataLayer.push({
						event: 'Add Balance Transaction Failed',
						'Payment Gateway':
							data.paymentInfo && data.paymentInfo.methodName ? data.paymentInfo.methodName : '',
						'PG Type':
							data.paymentInfo && data.paymentInfo.methodType
								? data.paymentInfo.methodType === 'refundable'
									? 'Credit'
									: 'PrePaid'
								: '',
						'NX Amount':
							data.productPurchaseInfo &&
							data.productPurchaseInfo.products &&
							data.productPurchaseInfo.products[0]
								? data.productPurchaseInfo.products[0].value
								: '',
					});
				}
				this.resultType = status;
				this.loading = false;
			} else if (this.paymentResult === 'failed') {
				const response = await this.$checkoutAPI.getTransactionTypeResult(this.checkoutId, this.paymentResult);
				const data = response.data;

				this.resultData = {
					orderNumber: data.orderNumber,
					returnURL: data.redirectUrl,
				};

				this.resultType = this.paymentResult;
				this.loading = false;

				dataLayer.push({
					event: 'Add Balance Transaction Failed',
					'Payment Gateway': data.methodName ? data.methodName : '',
					'PG Type': data.methodType ? (data.methodType === 'refundable' ? 'Credit' : 'PrePaid') : '',
					'NX Amount': data.products && data.products[0] ? data.products[0].value : '',
				});
			} else if (this.paymentResult === 'cancel') {
				const response = await this.$checkoutAPI.getTransactionTypeResult(this.checkoutId, this.paymentResult);
				this.goto(response.data.redirectUrl);
			} else {
				// return to the add balance
				window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
					this.$i18n.locale
				}/add-balance`;
			}
		} catch (error) {
			this.$router.replace({
				name: 'purchase-failed',
				query: {
					...(error.response && error.response.data && error.response.data.code
						? { error_code: error.response.data.code }
						: {}),
				},
			});
		}
	},
	methods: {
		dataLayerCompletedPending(data) {
			dataLayer.push({
				event: 'Add Balance Transaction Complete',
				'Payment Gateway': data.paymentInfo && data.paymentInfo.methodName ? data.paymentInfo.methodName : '',
				'PG Type':
					data.paymentInfo && data.paymentInfo.methodType
						? data.paymentInfo.methodType === 'refundable'
							? 'Credit'
							: 'PrePaid'
						: '',
				'NX Amount':
					data.productPurchaseInfo &&
					data.productPurchaseInfo.products &&
					data.productPurchaseInfo.products[0]
						? data.productPurchaseInfo.products[0].value
						: '',
				'Transaction status': data.status === 'complete' ? 'Complete' : 'Pending',
			});

			if (
				data.paymentInfo &&
				data.paymentInfo.methodName !== 'nexoncards' &&
				data.paymentInfo.methodName !== 'epin'
			) {
				dataLayer.push({ ecommerce: null });

				const products =
					data.productPurchaseInfo && data.productPurchaseInfo.products
						? data.productPurchaseInfo.products
						: [];

				dataLayer.push({
					event: 'purchase',
					ecommerce: {
						currencyCode: data.paymentInfo && data.paymentInfo.currency ? data.paymentInfo.currency : '',
						purchase: {
							actionField: {
								id: data.orderNumber,
								revenue:
									data.paymentInfo && data.paymentInfo.totalAmount
										? data.paymentInfo.totalAmount
										: '',
								tax: data.paymentInfo && data.paymentInfo.taxAmount ? data.paymentInfo.taxAmount : '',
								coupon: '',
							},
							products: [
								{
									name: products[0] ? products[0].name : '',
									variant:
										data.paymentInfo && data.paymentInfo.methodType
											? data.paymentInfo.methodType === 'refundable'
												? 'Credit'
												: 'PrePaid'
											: '',
									price: products[0] ? products[0].amount : '',
									category: 'NX',
									quantity: 1,
								},
							],
						},
					},
				});
			}
		},
	},
};
</script>
